/* eslint-disable react/prop-types */
import React from 'react';
export const MegaMenuMobileLink = ({ title, description, iconSrc, href, target }) => {
    return (React.createElement("a", { className: "mega-menu-mobile__link", href: href, target: target },
        !!description ? (React.createElement("div", { className: "mega-menu-mobile__link-description" },
            React.createElement("span", { className: "mega-menu-mobile__link-title" }, title),
            React.createElement("span", { className: "mega-menu-mobile__link-text" }, description))) : (React.createElement("span", null, title)),
        iconSrc && React.createElement("img", { src: iconSrc, width: 15, height: 15 })));
};
